import React from 'react';
import styles from './MainGraphics.css';
import pallet from '../../assets/pallet2.png';


const MainGraphics = () => {
    return (
        <div className={styles.mainImgWrap}>
            <img className={styles.mainImg} src={pallet} alt="pallet" />
        </div>
    )
};

export default MainGraphics;


// WEBPACK FOOTER //
// ./src/components/MainGraphics/MainGraphics.js